import React, { useContext } from 'react';
import { Cpu, Eye, PhoneCall } from 'react-feather';
import styled, { ThemeContext } from 'styled-components';
import theme from '../../theme';
import Container from '../Container';
import getColor, { Color } from '../utils/getColor';

export default () => {
  const themeContext = useContext(ThemeContext);
  return (
    <HowItWorks>
      <Container>
        <Wrapper>
          <CardContainer>
            <Item>
              <Card trimColor={Color.Blue}>
                <CardInner>
                  <CardHeading>Upload</CardHeading>
                  <IconContainer>
                    <PhoneCall color={themeContext.colors.grey700} />
                    {/* <UploadCloud color={themeContext.colors.grey700} /> */}
                  </IconContainer>
                  <CardCopy>
                    Upload your call audio to our secure endpoint in the cloud. daisee can handle both stereo and mono voice data, enabling us to seamlessly process all of your call interactions.
                  </CardCopy>
                </CardInner>
              </Card>
              <Number>1</Number>
            </Item>
            <Item>
              <Card trimColor={Color.Pink}>
                <CardInner>
                  <CardHeading>Evaluation</CardHeading>
                  <IconContainer>
                    <Cpu color={themeContext.colors.grey700} />
                    {/* <GitPullRequest color={themeContext.colors.grey700} /> */}
                  </IconContainer>
                  <CardCopy>
                    daisee transcribes, evaluates and filters voice data in near-real-time. All call audio is transcribed with best-in-class accuracy, then analysed to derive insights and identify patterns in the data.
                  </CardCopy>
                </CardInner>
              </Card>
              <Number>2</Number>
            </Item>
            <Item>
              <Card trimColor={Color.Yellow}>
                <CardInner>
                  <CardHeading>Insight</CardHeading>
                  <IconContainer>
                    <Eye color={themeContext.colors.grey700} />
                    {/* <Key color={themeContext.colors.grey700} /> */}
                  </IconContainer>
                  <CardCopy>
                    daisee provides actionable insights based on the transcribed and evaluated call data. This includes identifying trends in customer conversations, as well as detecting sentiment, intent, and other key metrics.  These insights enable businesses to make data-driven decisions to improve their products, services, and overall customer experience.
                  </CardCopy>
                </CardInner>
              </Card>
              <Number>3</Number>
            </Item>
          </CardContainer>
        </Wrapper>
      </Container>
      <Container>
        <Wrapper>
          <WorksForYou>
            <IconSVG>
              <svg width="88" height="70" viewBox="0 0 88 70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.2 29.6726C18.0538 29.6726 22 25.2371 22 19.7817C22 14.3263 18.0538 9.89086 13.2 9.89086C8.34625 9.89086 4.4 14.3263 4.4 19.7817C4.4 25.2371 8.34625 29.6726 13.2 29.6726ZM74.8 29.6726C79.6538 29.6726 83.6 25.2371 83.6 19.7817C83.6 14.3263 79.6538 9.89086 74.8 9.89086C69.9463 9.89086 66 14.3263 66 19.7817C66 25.2371 69.9463 29.6726 74.8 29.6726ZM79.2 34.618H70.4C67.98 34.618 65.7937 35.7153 64.1988 37.4925C69.74 40.908 73.6725 47.0743 74.525 54.3997H83.6C86.0338 54.3997 88 52.1897 88 49.4543V44.5089C88 39.0534 84.0537 34.618 79.2 34.618ZM44 34.618C52.5112 34.618 59.4 26.8753 59.4 17.309C59.4 7.74269 52.5112 0 44 0C35.4888 0 28.6 7.74269 28.6 17.309C28.6 26.8753 35.4888 34.618 44 34.618ZM54.56 39.5634H53.4188C50.5588 41.1089 47.3825 42.0361 44 42.0361C40.6175 42.0361 37.455 41.1089 34.5812 39.5634H33.44C24.695 39.5634 17.6 47.5379 17.6 57.367V61.8179C17.6 65.9133 20.5562 69.236 24.2 69.236H63.8C67.4437 69.236 70.4 65.9133 70.4 61.8179V57.367C70.4 47.5379 63.305 39.5634 54.56 39.5634ZM23.8013 37.4925C22.2063 35.7153 20.02 34.618 17.6 34.618H8.8C3.94625 34.618 0 39.0534 0 44.5089V49.4543C0 52.1897 1.96625 54.3997 4.4 54.3997H13.4613C14.3275 47.0743 18.26 40.908 23.8013 37.4925Z" fill="#A8B6BD"/>
              </svg>
            </IconSVG>
            <Article>
              <Tag sectionColor={theme.colors.grey400}>Understand and manage multiple teams</Tag>
              <Copy>
              <p>daisee provides team leaders, coaches, and supervisors with an overview of their complete teams’ performance and activity on one dashboard. This enables them to spend significantly less time scoring interactions and more time delivering engaging, data-driven feedback to agents.</p>
              </Copy>
            </Article>
          </WorksForYou>
          <WorksForYou>
            <IconSVG>
              <svg width="69" height="74" viewBox="0 0 69 74" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M34.5 0C15.3333 0 0 13.4545 0 30.2727V53.8182C0 56.4945 1.2116 59.0611 3.36827 60.9535C5.52494 62.8459 8.45001 63.9091 11.5 63.9091H23V37H7.66667V30.2727C7.66667 24.0281 10.4937 18.0392 15.526 13.6236C20.5582 9.20795 27.3834 6.72727 34.5 6.72727C41.6166 6.72727 48.4418 9.20795 53.474 13.6236C58.5063 18.0392 61.3333 24.0281 61.3333 30.2727V37H46V63.9091H61.3333V67.2727H34.5V74H57.5C60.55 74 63.4751 72.9369 65.6317 71.0444C67.7884 69.152 69 66.5854 69 63.9091V30.2727C69 13.4545 53.5517 0 34.5 0Z" fill="#A8B6BD"/>
              </svg>
            </IconSVG>
            <Article>
              <Tag sectionColor={theme.colors.grey400}>Give power to your agents to evaluate their own efforts</Tag>
              <Copy>
              <p>daisee’s Agent View empowers agents to view their own performance and activity data. This includes team comparison over time across the three key themes of communication, compliance, and conduct - enabling agents the autonomy to reflect and review their activity.</p>
              </Copy>
            </Article>
          </WorksForYou>
          <WorksForYou>
            <IconSVG>
              <svg width="76" height="83" viewBox="0 0 76 83" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M33.1769 60.0367L16.0769 83L11.6923 71.9333H0L14.9077 52.705C17.8308 54.365 20.9 54.6417 23.0923 55.0567C23.8231 55.195 24.7 55.3333 25.1385 55.3333C25.4308 55.4717 26.1615 56.025 26.6 56.44C28.3538 57.5467 30.5462 59.2067 33.1769 60.0367ZM61.0923 52.705C58.1692 54.365 55.1 54.6417 52.9077 55.0567C52.1769 55.195 51.1538 55.3333 50.7154 55.3333C50.4231 55.4717 49.6923 56.025 49.2538 56.44C47.6462 57.5467 45.6 59.2067 42.8231 60.0367L59.9231 83L64.3077 71.9333H76L61.0923 52.705ZM38 16.6C32.3 16.6 27.7692 20.8883 27.7692 26.2833C27.7692 31.6783 32.3 35.9667 38 35.9667C43.7 35.9667 48.2308 31.6783 48.2308 26.2833C48.2308 20.8883 43.7 16.6 38 16.6ZM65.7692 26.2833C65.7692 29.6033 61.9692 32.2317 60.6538 35.1367C59.3385 38.18 60.0692 42.6067 57.5846 44.82C55.2462 47.0333 50.5692 46.48 47.3538 47.725C44.2846 48.97 41.5077 52.5667 38 52.5667C34.4923 52.5667 31.7154 48.97 28.6462 47.725C25.4308 46.48 20.7538 47.1717 18.4154 44.82C16.0769 42.6067 16.6615 38.18 15.3462 35.1367C14.0308 32.2317 10.2308 29.6033 10.2308 26.2833C10.2308 22.9633 14.0308 20.335 15.3462 17.43C16.6615 14.3867 15.9308 9.96 18.4154 7.74667C20.7538 5.53333 25.4308 6.08667 28.6462 4.84167C31.7154 3.59667 34.4923 0 38 0C41.5077 0 44.2846 3.59667 47.3538 4.84167C50.5692 6.08667 55.2462 5.395 57.5846 7.74667C59.9231 9.96 59.3385 14.3867 60.6538 17.43C61.9692 20.335 65.7692 22.9633 65.7692 26.2833ZM57 26.2833C57 16.3233 48.5231 8.3 38 8.3C27.4769 8.3 19 16.3233 19 26.2833C19 36.2433 27.4769 44.2667 38 44.2667C48.5231 44.2667 57 36.2433 57 26.2833Z" fill="#A8B6BD"/>
              </svg>
            </IconSVG>
            <Article>
              <Tag sectionColor={theme.colors.grey400}>Motivate and coach your team with the Agent Performance Workflow</Tag>
              <Copy>
              <p>The integrated Agent Performance Workflow enables you to measure both individual agent productivity and their relative performance to any given number of teams over time. The Agent Performance Workflow not only empowers businesses to coach and quantify agent performance but is also regularly used for positive reinforcement — increased agent morale leads to increased levels of productivity.</p>
              </Copy>
            </Article>
          </WorksForYou>
        </Wrapper>
      </Container>
    </HowItWorks>
  );
};

const HowItWorks = styled.article`
  background: ${({ theme }) => theme.colors.grey200};
  border-top: 1px solid ${({ theme }) => theme.colors.grey300};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey300};
  overflow: hidden;
`;

const Number = styled.p`
  color: ${({ theme }) => theme.colors.grey500};
  -webkit-text-fill-color: ${({ theme }) => theme.colors.grey200};
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: ${({ theme }) => theme.colors.grey500};
  position: absolute;
  left: 1.5rem;
  top: -1.5rem;
  font-size: 4rem;
`;

const Wrapper = styled.div`
  padding: 6rem 1.5rem 3rem;
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  @media all and (max-width: 48em) {
    grid-template-columns: 1fr;
    gap: 6rem;
  }
`;

const CardCopy = styled.p`
  color: ${({ theme }) => theme.colors.grey700};
  font-size: 0.875rem;
`;

const IconContainer = styled.div`
  gap: 1.5rem;
  padding-bottom: 1.5rem;
  grid-auto-flow: column;
  display: inline-grid;
`;

interface CardProps {
  trimColor: Color;
}

const Item = styled.div`
  position: relative;
`;

const Card = styled.div<CardProps>`
  box-shadow: ${({ theme }) => theme.boxShadow.small};
  background: #fff;
  position: relative;
  z-index: 2;
  border-radius: 4px;
  transition: box-shadow 0.75s ease;
  height: 100%;

  &:hover {
    box-shadow: ${({ theme }) => theme.boxShadow.large};
  }

  &:before {
    content: '';
    position: absolute;
    background: ${({ trimColor }) => getColor(trimColor)};
    width: 100%;
    height: 4px;
    top: 0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

const CardHeading = styled.h3`
  font-weight: 600;
  font-size: 1.5rem;
  padding-bottom: 1.5rem;
  line-height: 1;
`;

const CardInner = styled.div`
  padding: 1.5rem;
`;

const WorksForYou = styled.div`
  display: flex;
`;

const IconSVG = styled.div`
  width: 20%;
  display: flex;
  justify-content: center;
`;

const Article = styled.div`
  width: 80%;
`;

interface TagProps {
  sectionColor: Color | string;
}
const Tag = styled.p<TagProps>`
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.grey400};
  user-select: none;
  height: fit-content;
  position: relative;
  padding-left: 1.5rem;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    height: 100%;
    background: ${({ sectionColor }) => getColor(sectionColor)};
    width: 4px;
  }
`;

const Copy = styled.div`
  p {
    padding: 1rem 1rem 3rem 0;
  }
`;